import { formatDate } from '@angular/common';

import { formats } from '@environment';

export function formatReportDateTime(value: string | Date, format: string = formats.reportDateTime): string {
  if (!value) {
    return null;
  }

  return formatDate(value, format, 'en-US', 'GMT');
}
